module.exports = __webpack_public_path__ + "static/media/primary-staff.1d18970e.svg";